export const MANUFACTURING_BASE = "/manufacturing";

export const workflowPaths = {
  base: () => `${MANUFACTURING_BASE}/workflows`,
  cellList: () => `${MANUFACTURING_BASE}/workflows/cell`,
  cellNew: () => `${MANUFACTURING_BASE}/workflows/cell/new`,
  cellEdit: (id: string) => `${MANUFACTURING_BASE}/workflows/cell/${id}/edit`,
  packList: () => `${MANUFACTURING_BASE}/workflows/pack`,
  packNew: () => `${MANUFACTURING_BASE}/workflows/pack/new`,
  packEdit: (id: string) => `${MANUFACTURING_BASE}/workflows/pack/${id}/edit`,
};

export const cellMfgPaths = {
  base: () => `${MANUFACTURING_BASE}/cell`,
  lots: () => `${MANUFACTURING_BASE}/cell/lots`,
  lotRegister: () => `${MANUFACTURING_BASE}/cell/lots/register`,
  lotDetail: (cellModelId: string, lotId: string, tabId?: string) =>
    `${MANUFACTURING_BASE}/cell/lots/${cellModelId}/${encodeURIComponent(lotId)}${tabId ? `/${tabId}` : ""}`,
  events: () => `${MANUFACTURING_BASE}/cell/events`,
  eventIngest: () => `${MANUFACTURING_BASE}/cell/events/ingest`,
  bulkUpload: () => `${MANUFACTURING_BASE}/cell/events/bulk-upload`,
  workflows: () => workflowPaths.cellList(),
  workflowEditor: (id: string) =>
    id === "new" ? workflowPaths.cellNew() : workflowPaths.cellEdit(id),
  quality: () => `${MANUFACTURING_BASE}/cell/quality`,
  scrap: () => `${MANUFACTURING_BASE}/cell/scrap`,
  trace: () => `${MANUFACTURING_BASE}/cell/trace`,
  yieldAnalytics: () => `${MANUFACTURING_BASE}/cell/floor-intelligence/yield`,
  yieldInsight: (id: string) =>
    `${MANUFACTURING_BASE}/cell/floor-intelligence/yield/insights/${id}`,
  processImpact: () =>
    `${MANUFACTURING_BASE}/cell/floor-intelligence/process-impact`,
  fieldImpact: () =>
    `${MANUFACTURING_BASE}/cell/field-intelligence/field-impact`,
};

export const batteryMfgPaths = {
  base: () => `${MANUFACTURING_BASE}/battery`,
  lots: () => `${MANUFACTURING_BASE}/battery/lots`,
  lotRegister: () => `${MANUFACTURING_BASE}/battery/lots/register`,
  lotDetail: (id: string, tabId?: string) =>
    `${MANUFACTURING_BASE}/battery/lots/${id}${tabId ? `/${tabId}` : ""}`,
  workflows: () => workflowPaths.packList(),
  workflowEditor: (id: string) =>
    id === "new" ? workflowPaths.packNew() : workflowPaths.packEdit(id),
};
